/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_TitleInputs */

const vi_payment_qr_title = /** @type {(inputs: Payment_Qr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán chuyển khoản`)
};

/**

* @param {Payment_Qr_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_title = /** @type {((inputs?: Payment_Qr_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_title(inputs)
});